import React, { useState, useRef } from 'react';
import { Carousel, Button } from 'antd';
import LazyLoad from 'react-lazyload';
import Container from './Container';
// logos
import Foton from '../images/foton.png';
import Samsclub from '../images/samsclub.svg';
import SpdBank from '../images/spd-bank.svg';

const CAROUSEL_DATA = [
  {
    logoName: 'SPD Bank',
    logoSrc: SpdBank,
    content:
      '面对着海量用户但活跃度偏低，运营人员数量有限，精细化运营无法有效达成等挑战，浦发银行基于现有数据管理平台，通过DM Hub 产品搭建互联网营销运营平台，实现精准高效的客户互动和营销活动参与率的大幅提升，形成数据驱动的自动化精准营销能力。',
  },
  {
    logoName: 'samsclub',
    logoSrc: Samsclub,
    content:
      '山姆CRM系统管理着200多万的会员，但无法满足山姆的实际运营需求，Convertlab为其建立了客户数据平台（Customer Data Platform，CDP），包含消费者的完整历史数据和各个触点的行为数据，能够将所有数据整合分析实现消费者洞察以进一步提供个性化营销，最终实现千人千面的营销策略。',
  },
  {
    logoName: '福田汽车',
    logoSrc: Foton,
    content:
      '福田汽车自2016年自建电商及售后服务APP（福田e家）后累计了600万条车主数据，但数据质量有待提升，人、车、联系人数据不够清晰，数据无法形成有效资产促进决策。通过搭建CDP平台进行数据治理，运营管理形成一体化，福田得以梳理出会员全渠道营销场景MOT全景图，实现精准且个性化的数字营销。',
  },
];

const CAROUSEL_LENGTH = CAROUSEL_DATA.length;

const LOGO_DATA = [
  { logoIndex: 6, logoName: 'CapitaLand' },
  { logoIndex: 4, logoName: 'Budweiser' },
  { logoIndex: 23, logoName: 'UNIQLO' },
  { logoIndex: 15, logoName: 'IKEA' },
  { logoIndex: 1, logoName: 'adidas' },
  { logoIndex: 5, logoName: 'BVLGARI' },
  { logoIndex: 11, logoName: 'DFS' },
  { logoIndex: 13, logoName: 'Fonterra' },
  { logoIndex: 17, logoName: 'Coca-Cola' },
  { logoIndex: 14, logoName: '华润' },
  { logoIndex: 21, logoName: 'TCL' },
  { logoIndex: 25, logoName: 'StanleyBlack&Decker' },
  { logoIndex: 2, logoName: 'ASUS' },
  { logoIndex: 3, logoName: 'Blueair' },
  { logoIndex: 16, logoName: '水井坊' },
  { logoIndex: 24, logoName: 'VORWERK' },
  { logoIndex: 12, logoName: 'EF教育' },
  { logoIndex: 7, logoName: 'Club Med' },
  { logoIndex: 22, logoName: 'The Economist' },
  { logoIndex: 20, logoName: '第1财经' },
  { logoIndex: 19, logoName: 'Chiaus' },
  { logoIndex: 10, logoName: 'Samsclub' },
  { logoIndex: 9, logoName: 'Spd Bank' },
  { logoIndex: 18, logoName: 'DDI 50' },
  { logoIndex: 8, logoName: 'Osm' },
];

export default function HomeLogos() {
  const carouselRef = useRef();
  const [carouselIndex, setCarouselIndex] = useState(0);

  // 走马灯按钮：向左
  function onCarouselGoLeft() {
    setCarouselIndex(carouselIndex - 1 < 0 ? CAROUSEL_LENGTH - 1 : carouselIndex - 1);
    carouselRef.current.prev();
  }

  // 走马灯按钮：向右
  function onCarouselGoRight() {
    setCarouselIndex(carouselIndex + 1 > CAROUSEL_LENGTH - 1 ? 0 : carouselIndex + 1);
    carouselRef.current.next();
  }

  return (
    <section id="logos" className="home-logos">
      <Container fluid="xl">
        <h3>300+顶尖企业的共同选择</h3>
        <div className="carousel-with-btns">
          <Carousel autoplay ref={carouselRef} effect="fade">
            {CAROUSEL_DATA.map((carouselItem) => (
              <div className="carousel-content-wrapper" key={carouselItem.logoName}>
                <div className="carousel-content">
                  <img
                    className="carousel-logo"
                    src={carouselItem.logoSrc}
                    alt={carouselItem.logoName}
                  />
                  <span className="iconfont font-24 icondouble-quot-left quot-left" />
                  {/* <img src={DoubleQuotLeft} className="quot-left" alt="quot" /> */}
                  <h3>{carouselItem.content}</h3>
                  <span className="iconfont font-24 icondouble-quot-right quot-right" />
                  {/* <img src={DoubleQuotRight} className="quot-right" alt="quot" /> */}
                  <div className="clear" />
                </div>
              </div>
            ))}
          </Carousel>
          <Button onClick={onCarouselGoLeft} className="carousel-btn left">
            {/* <img src={LessThan} alt="lt" /> */}
            <span className="iconfont font-24 iconless-than" />
          </Button>
          <Button onClick={onCarouselGoRight} className="carousel-btn right">
            {/* <img src={GreaterThan} alt="gt" /> */}
            <span className="iconfont font-24 icongreater-than" />
          </Button>
        </div>
      </Container>
      <Container>
        <LazyLoad>
          <div className="logos">
            {LOGO_DATA.map((logoItem) => {
              const { logoIndex } = logoItem;
              const columnIndex = Math.ceil(logoIndex / 10) - 1;
              const rowIndex = logoIndex - columnIndex * 10;
              const positionX = columnIndex * 500;
              const positionY = (rowIndex - 1) * 150;
              const xStr = positionX ? `-${positionX}px` : '0px';
              const yStr = positionY ? `-${positionY}px` : '0px';
              return (
                <div className="logo" key={logoItem.logoName}>
                  <div className="logo-image" style={{ backgroundPosition: `${xStr} ${yStr}` }} />
                </div>
              );
            })}
          </div>
        </LazyLoad>
      </Container>
    </section>
  );
}
